import { AccountantAccessChatCard } from "components/ChatCard/AccountantAccessChatCard/AccountantAccessChatCard";
import { EstimatedTaxQuarterlyCard } from "components/ChatCard/EstimatedTaxQuarterlyCard/EstimatedTaxQuarterlyCard";
import { AdminCallCard } from "components/ChatCard/AdminCallCard/AdminCallCard";
import { AIQuestionCard } from "components/ChatCard/AIQuestionCard/AIQuestionCard";
import { AIReconcileCard } from "components/ChatCard/AIReconcileCard/AIReconcileCard";
import { CreateEntityCard } from "components/ChatCard/CreateEntityCard/CreateEntityCard";
import { BillDraftCard } from "components/ChatCard/AIDraftBillCard/AIDraftBillCard";
import { InvoiceDraftCard } from "components/ChatCard/AIDraftBillCard/InvoiceDraftCard";
import { CustomerFeedbackCard } from "components/ChatCard/CustomerFeedbackCard/CustomerFeedbackCard";
import { DftFilingDraftCard } from "components/ChatCard/DftFilingDraftCard/DftFilingDraftCard";
import { EsignCard } from "components/ChatCard/EsignCard";
import { FilingDraftCard } from "components/ChatCard/FilingDraftCard/FilingDraftCard";
import { CommentChatCard } from "components/ChatCard/CommentChatCard";
import { MerchantEmailRequestCard } from "components/ChatCard/MerchantEmailRequestCard";
import { RaiseClarificationCard } from "components/ChatCard/RaiseClarificationCard";
import { RequestAnswerChatCard } from "components/ChatCard/RequestAnswers/RequestAnswerChatCard";
import { RequestedInfoChatCard } from "components/ChatCard/RequestedInfoChatCard";
import { ReviewClosingCard } from "components/ChatCard/ReviewClosingCard";
import { ReviewMessageChatCard } from "components/ChatCard/ReviewMessageChatCard";
import { SensitiveDataCard } from "components/ChatCard/SensitiveDataCard";
import { TicketCard } from "components/ChatCard/TicketCard/TicketCard";
import { TransactionChatCard } from "components/ChatCard/TransactionChatCard";
import { CartChatCard } from "components/design/CartAttachmentPreview";
import { OpenItemCard } from "components/MessageInput/OpenItemCard";
import { RequestDocumentsChatCard } from "components/RequestDocumentsChatCard/RequestDocumentsChatCard";
import MeetingRequestChatCard from "components/ChatCard/MeetingRequestChatCard/MeetingRequestChatCard";
import {
  ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE,
  AI_QUESTION_CARD_CUSTOM_TYPE,
  ESTIMATED_TAX_QUARTERLY_CARD_TYPE,
  CALL_LOG_CUSTOM_TYPE,
  CART,
  CHAT_CARD_TYPE,
  COMMENT_CARD_CUSTOM_TYPE,
  CREATE_ENTITY_CARD_CUSTOM_TYPE,
  CUSTOMER_FEEDBACK_CUSTOM_TYPE,
  ESIGN_REQUEST_CUSTOM_TYPE,
  FINANCIAL_CLOSING_CARD_TYPE,
  MEETING_REQUEST_CUSTOM_TYPE,
  MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE,
  OPEN_ITEM_CUSTOM_TYPE,
  PRICED_TICKET_CARD,
  REQUESTED_ANSWERS_CUSTOM_TYPE,
  REQUESTED_DFT_REVIEW_TYPE,
  REQUESTED_DOCUMENTS_CUSTOM_TYPE,
  REQUESTED_INFO_CUSTOM_TYPE,
  REQUESTED_REVIEW_DRAFT_TYPE,
  REVIEW_AI_RECONCILIATION,
  REVIEW_DRAFT_BILL,
  REVIEW_DRAFT_INVOICE,
  SENSITIVE_DATA_CUSTOM_TYPE,
  TICKET_CARD,
  TRANSACTIONS,
} from "constants/chatType";
import { DEPRECATED } from "constants/sensitiveData";
import { useDefaultEntity } from "hooks/useDefaultEntity";
import { FC, ReactNode } from "react";
import { useChannelStateContext } from "stream-chat-react";

type Cardsprops = {
  type: string;
  customData: any;
  messageId: string;
  children?: ReactNode;
  size?: "regular" | "block";
  card_status: string;
  entityId?: string;
  groupId: string;
};
export const Cards: FC<Cardsprops> = ({
  type,
  customData,
  messageId,
  size = "regular",
  children,
  card_status,
  entityId,
  groupId,
}) => {
  const { channel } = useChannelStateContext();
  const defaultEntity = useDefaultEntity();
  const isDeprecated = card_status === DEPRECATED;

  switch (type) {
    case CUSTOMER_FEEDBACK_CUSTOM_TYPE:
      return (
        <CustomerFeedbackCard
          feedback={customData.metadata?.feedback}
          header={customData.header}
          size={size}
          groupId={groupId!}
        />
      );
    case CHAT_CARD_TYPE:
      return (
        <ReviewMessageChatCard
          customData={customData}
          messageId={messageId}
          size={size}
          isDeprecated={isDeprecated}
        />
      );

    case CALL_LOG_CUSTOM_TYPE:
      return <AdminCallCard customData={customData} />;

    case TICKET_CARD:
    case PRICED_TICKET_CARD:
      return (
        <TicketCard
          customData={customData}
          messageId={messageId}
          groupId={groupId}
          entityId={entityId}
        />
      );

    case OPEN_ITEM_CUSTOM_TYPE:
      return (
        <OpenItemCard
          customData={customData}
          messageId={messageId}
          size={size}
          isDeprecated={isDeprecated}
        />
      );

    case REQUESTED_DOCUMENTS_CUSTOM_TYPE:
      return channel.id ? (
        <RequestDocumentsChatCard
          customData={customData}
          groupId={groupId}
          channelId={channel.id}
          entityId={entityId || (channel?.data?.entity_id as string) || ""}
          size={size}
          isDeprecated={isDeprecated}
        >
          {children}
        </RequestDocumentsChatCard>
      ) : null;

    case TRANSACTIONS:
      return (
        <TransactionChatCard
          customData={customData}
          groupId={groupId}
          messageId={messageId}
        >
          {children}
        </TransactionChatCard>
      );

    case REQUESTED_INFO_CUSTOM_TYPE:
      return (
        <RequestedInfoChatCard
          customData={customData}
          groupId={groupId}
          messageId={messageId}
          channelId={channel.id!}
          size={size}
          isDeprecated={isDeprecated}
        />
      );

    case ESIGN_REQUEST_CUSTOM_TYPE:
      return (
        <EsignCard
          customData={customData}
          groupId={groupId}
          messageId={messageId}
          size={size}
          isDeprecated={isDeprecated}
        />
      );

    case SENSITIVE_DATA_CUSTOM_TYPE:
      return (
        <SensitiveDataCard
          customData={customData}
          groupId={groupId}
          messageId={messageId}
          size={size}
        />
      );

    case FINANCIAL_CLOSING_CARD_TYPE.CLARIFICATION_RAISED:
      return (
        <RaiseClarificationCard customData={customData}>
          {children}
        </RaiseClarificationCard>
      );

    case FINANCIAL_CLOSING_CARD_TYPE.REVIEW_FINANCIAL:
      return (
        <ReviewClosingCard customData={customData} isDeprecated={isDeprecated}>
          {children}
        </ReviewClosingCard>
      );

    case CART:
      return (
        <CartChatCard
          entityId={customData?.entity_id!}
          groupId={groupId || customData?.group_id!}
          custom_data={customData}
          card_status={card_status}
        >
          {children}
        </CartChatCard>
      );

    case REQUESTED_ANSWERS_CUSTOM_TYPE:
      return (
        <RequestAnswerChatCard
          customData={customData}
          groupId={groupId}
          size={size}
        />
      );

    case REQUESTED_REVIEW_DRAFT_TYPE:
      return (
        <FilingDraftCard
          customData={customData}
          groupId={groupId}
          size="block"
        />
      );

    case REQUESTED_DFT_REVIEW_TYPE:
      return (
        <DftFilingDraftCard
          customData={customData}
          groupId={groupId}
          size="block"
        />
      );

    case REVIEW_DRAFT_BILL:
      return (
        <BillDraftCard
          groupId={groupId || customData?.group_id!}
          entityId={entityId || ""}
          billId={customData.bill_id}
        />
      );

    case REVIEW_DRAFT_INVOICE:
      return (
        <InvoiceDraftCard
          groupId={groupId || customData?.group_id!}
          entityId={entityId || ""}
          invoiceId={customData.invoice_id}
        />
      );

    case MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE:
      return (
        <MerchantEmailRequestCard
          customData={customData}
          messageId={messageId}
          size="block"
        />
      );

    case REVIEW_AI_RECONCILIATION:
      return (
        <AIReconcileCard
          entityId={customData?.entity_id || entityId || ""}
          reconciliationStateId={customData.reconciliation_state_id}
        />
      );

    case COMMENT_CARD_CUSTOM_TYPE:
      return <CommentChatCard customData={customData} groupId={groupId} />;

    case ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE:
      return (
        <AccountantAccessChatCard
          customData={customData}
          size={size}
          messageId={messageId}
        />
      );

    case ESTIMATED_TAX_QUARTERLY_CARD_TYPE:
      return <EstimatedTaxQuarterlyCard customData={customData} />;

    case MEETING_REQUEST_CUSTOM_TYPE:
      return (
        <MeetingRequestChatCard
          customData={customData}
          size={size}
          isDeprecated={isDeprecated}
        />
      );

    case AI_QUESTION_CARD_CUSTOM_TYPE:
      return (
        <AIQuestionCard
          customData={customData}
          messageId={messageId}
          entityId={entityId || defaultEntity?.uuid}
          groupId={groupId}
          cardStatus={card_status}
        />
      );

    case CREATE_ENTITY_CARD_CUSTOM_TYPE:
      return (
        <CreateEntityCard
          customData={customData}
          messageId={messageId}
          groupId={groupId}
          cardStatus={card_status}
        />
      );

    default:
      return null;
  }
};
